import algoliasearch from "algoliasearch";

// A missing key must never take the app down. `algolia` is imported at module
// scope by Header, CarSummary and ~15 dialogs, so a constructor that throws
// white-screens all of Tools instead of just breaking search. When the key is
// absent we log once and hand back a stub client that answers every query with
// no hits: search finds nothing, and everything else keeps working.
const emptyResult = { hits: [], nbHits: 0, page: 0, nbPages: 0 };

const stubIndex = {
  search: async () => ({ ...emptyResult }),
  setSettings: async () => {},
};

const stubClient = {
  initIndex: () => stubIndex,
  search: async (queries = []) => ({ results: queries.map(() => ({ ...emptyResult })) }),
  multipleQueries: async (queries = []) => ({ results: queries.map(() => ({ ...emptyResult })) }),
};

class Algolia {
  constructor() {
    const searchKey = process.env.REACT_APP_ALGOLIA_SEARCH_KEY;
    if (!searchKey) {
      console.warn(
        'Missing REACT_APP_ALGOLIA_SEARCH_KEY — search is disabled. Set it to a search-only Algolia API key at build time.'
      );
      Object.assign(this, { client: stubClient, enabled: false });
      return;
    }
    const client = algoliasearch(
      process.env.REACT_APP_ALGOLIA_APP_ID || 'KKARPLYFGH',
      searchKey
    );
    Object.assign(this, { client, enabled: true });
  }
}

const algolia = new Algolia();
export default algolia;
